import { css } from '@emotion/css';

export const styles = {
  modal: css`
    flex: 1;
    overflow-y: auto;
    z-index: 0;
    padding: 24px;
    @media (max-width: 668px) {
      padding-bottom: 0;
    }
  `,
  headersContainer: css`
    flex: 1 1 auto;
    min-width: 0;
  `,
  plusValueImg: css`
    flex-shrink: 0;
  `,
  explanationContainer: css`
    margin-bottom: 12px;
  `,
  aragPartnershipContainer: css`
    display: flex;
    gap: 12px;
  `,
  optionsContainer: css`
    gap: var(--size-600);
    flex-wrap: wrap;
  `,
} as const;
